import { useEffect, useState, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, isAdmin } from '../lib/auth';

interface Props {
  children: ReactNode;
}

type Check = 'loading' | 'admin' | 'not-admin';

export default function RequireAdmin({ children }: Props) {
  const auth = useAuth();
  const [check, setCheck] = useState<Check>('loading');

  useEffect(() => {
    if (auth.status !== 'authenticated') return;
    let active = true;
    isAdmin(auth.user.id).then((ok) => {
      if (active) setCheck(ok ? 'admin' : 'not-admin');
    });
    return () => {
      active = false;
    };
  }, [auth.status, auth.status === 'authenticated' ? auth.user.id : null]);

  if (auth.status === 'loading') {
    return <Spinner />;
  }
  if (auth.status === 'anonymous') {
    return <Navigate to="/login" replace />;
  }
  if (check === 'loading') {
    return <Spinner />;
  }
  if (check === 'not-admin') {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}

function Spinner() {
  return (
    <div className="flex items-center justify-center min-h-screen text-gray-400 text-sm">
      <span>Đang tải…</span>
    </div>
  );
}
